/* TPS family switcher (deferred): touch head start, readiness, paint-first switch, scroll keeping, VT scoping, peek. Hover prefetch = Shopify header rule. Notes: snippets/tps-colour-band.liquid */
(function(){
var K="tps-cband";
var bands=document.querySelectorAll("[data-cband]");
if(!bands.length) return;
var spec=!!(window.HTMLScriptElement&&HTMLScriptElement.supports&&HTMLScriptElement.supports("speculationrules"));
var rm=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;
var nt=performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];
var est=Math.max(250,nt?1.5 * (nt.responseEnd-nt.requestStart):600);
var ready={};
function key(a){return a.pathname+a.search;}
function warm(a){
if(a.hasAttribute("aria-current")) return;
var u=a.href;
if(ready[u]) return;
var el;
if(spec){
ready[u]=Date.now()+est;
el=document.createElement("script");
el.type="speculationrules";
el.textContent=JSON.stringify({prefetch: [{source: "list",urls: [u],eagerness: "immediate"}]});
} else{
ready[u]=Infinity;
el=document.createElement("link");
el.rel="prefetch";
el.href=u;
el.onload=function(){ready[u]=Date.now();};
}
document.head.appendChild(el);
}
function isReady(a){return !!ready[a.href]&&Date.now()>=ready[a.href];}
function quiet(t){
["ready","finished","updateCallbackDone"].forEach(function(k){if(t[k]) t[k].catch(function(){});});
}
var conn=navigator.connection;
var lean=!!(conn&&(conn.saveData||/2g/.test(conn.effectiveType||"")));
var touch=window.matchMedia&&matchMedia("(hover: none) and (pointer: coarse)").matches;
var stage=document.querySelector(".pdpv9 .stage-frame");
var deck=stage&&stage.querySelector(".deck");
Array.prototype.forEach.call(bands,function(band){
var sel=band.querySelector("[data-cband-sel]");
var home=sel?sel.innerHTML:"";
var orig={home: home,on: band.querySelector("li.is-on")};
var fam=band.getAttribute("data-cband-fam"),kd=band.classList.contains("cband--tiles")?"style":"colour",sw=0;
function pub(n,o){var A=window.Shopify&&Shopify.analytics;o.fam=fam;o.kind=kd;if(fam&&A&&A.publish)try{A.publish(n,o);}catch(e){}}
try{var rf=document.referrer;sw=+(nt.type=="navigate"&&[].some.call(band.querySelectorAll("a[data-cband-a]"),function(x){return x.href==rf;}));}catch(err){}
addEventListener("load",function(){pub("family_view",{sw: sw});});
var hoverT=0,backT=0;
if(touch&&!lean&&"IntersectionObserver" in window){
var arm=function(){
var io=new IntersectionObserver(function(es){
if(!es.some(function(x){return x.isIntersecting;})) return;
io.disconnect();
var as=Array.prototype.slice.call(band.querySelectorAll("a[data-cband-a]"));
var ci=as.findIndex(function(x){return x.hasAttribute("aria-current");});
as.map(function(x,i){return [Math.abs(i-ci),i,x];}).filter(function(r){return r[1]!==ci;})
.sort(function(p,q){return p[0]-q[0]||p[1]-q[1];}).slice(0,3).forEach(function(r){warm(r[2]);});
},{threshold: 0.5});
io.observe(band);
};
var idle=function(){(window.requestIdleCallback||function(f){setTimeout(f,300);})(arm);};
if(document.readyState==="complete") idle();else window.addEventListener("load",idle,{once: true});
}
function reset(){
clearTimeout(backT);
var now=band.querySelector("li.is-on");
if(now!==orig.on){if(now) now.classList.remove("is-on");if(orig.on) orig.on.classList.add("is-on");}
home=orig.home;
if(sel){sel.innerHTML=home;sel.classList.remove("is-peek");}
band.removeAttribute("aria-busy");
if(stage) stage.classList.remove("is-veil");
}
window.addEventListener("pageshow",function(e){if(e.persisted) reset();});
function pick(a){
var li=a.closest("li"),was=band.querySelector("li.is-on");
if(li&&li!==was){if(was) was.classList.remove("is-on");li.classList.add("is-on");}
if(sel){sel.textContent=a.getAttribute("data-name");sel.classList.remove("is-peek");}
}
band.addEventListener("focusin",function(e){
var a=e.target.closest("[data-cband-a]");
if(a) warm(a);
});
band.addEventListener("pointerover",function(e){
var a=e.target.closest("[data-cband-a]");
if(!a||e.pointerType!=="mouse") return;
clearTimeout(hoverT);
hoverT=setTimeout(function(){if(spec&&!ready[a.href]) ready[a.href]=Date.now()+est;},200);
if(sel){
sel.textContent=a.getAttribute("data-name");
sel.classList.toggle("is-peek",!a.hasAttribute("aria-current"));
}
});
band.addEventListener("pointerleave",function(){
clearTimeout(hoverT);
if(sel&&!band.hasAttribute("aria-busy")){sel.innerHTML=home;sel.classList.remove("is-peek");}
});
band.addEventListener("click",function(e){
var a=e.target.closest("[data-cband-a]");
if(!a||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
if(a.hasAttribute("aria-current")){e.preventDefault();return;}
if(a.origin!==location.origin||band.hasAttribute("aria-busy")){if(band.hasAttribute("aria-busy")) e.preventDefault();return;}
e.preventDefault();
var cur=band.querySelector("[aria-current]");
try {
sessionStorage.setItem(K,JSON.stringify({u: key(a),y: Math.round(scrollY),b: Math.round(band.getBoundingClientRect().top),k: e.detail===0?1:0,t: Date.now()}));
var bk=JSON.parse(sessionStorage.getItem(K+"-back")||"{}");
bk[location.pathname+location.search]=Math.round(band.getBoundingClientRect().top);
sessionStorage.setItem(K+"-back",JSON.stringify(bk));
} catch (err){}
pick(a);
if(sel) home=sel.innerHTML;
band.setAttribute("aria-busy","true");
var gone=0;
function go(){if(!gone){gone=1;try{history.scrollRestoration="manual"}catch(e){}location.assign(a.href);}}
function frames(n){var f=function(){if(--n<=0) go();else requestAnimationFrame(f);};requestAnimationFrame(f);setTimeout(go,150+20 * n);}
backT=setTimeout(reset,8000);
var r=stage&&stage.getBoundingClientRect();
var seen=r&&r.height?Math.max(0,Math.min(r.bottom,innerHeight)-Math.max(r.top,0)) / r.height:0;
var vl=!(isReady(a)||seen<0.3||!deck);
pub("colour_switch",{from: cur&&cur.getAttribute("data-name"),to: a.getAttribute("data-name"),ready: +isReady(a),veil: +vl});
if(!vl){frames(2);return;}
stage.classList.add("is-veil");
if(rm){frames(1);return;}
var settled=0;
function after(){if(!settled){settled=1;frames(1);}}
deck.addEventListener("transitionend",after,{once: true});
setTimeout(after,200);
});
});
window.addEventListener("pageswap",function(e){
if(!e.viewTransition) return;
quiet(e.viewTransition);
var to=e.activation&&e.activation.entry&&e.activation.entry.url;
var d=null;
try {d=JSON.parse(sessionStorage.getItem(K)||"null");} catch (err){}
var ok=false;
if(to&&d&&Date.now()-d.t<15000){
var u=new URL(to);
ok=u.origin===location.origin&&u.pathname+u.search===d.u;
}
if(!ok) e.viewTransition.skipTransition();
});
})();
